import { Routes, RouterModule } from '@angular/router';

const communityGrantRoutes: Routes = [];

export const CommunityGrantRouter = RouterModule.forChild(communityGrantRoutes);